module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_70_80.f70c477c.png";